import { Dropdown } from 'antd'
import classNames from 'classnames'
import { ReactNode } from 'react'
import { useRouter } from 'next/router'
import { MyLink } from '../ui/MyLink'
import { CDNImage } from './CDNImage'
import { MenuProps } from 'antd/lib/menu'

export interface NavItemProps {
  /** 名称 */
  name: string
  /** 跳转路径 */
  href: string
  /**  是否已在当前站点上存在 */
  exist: boolean
  host?: string
  /** 显示 vip icon */
  isVip?: boolean
  /** 显示 new icon */
  isNew?: boolean
  /** dropDown items */
  items?: MenuProps['items']
}

export const HeaderNavItem = ({
  navItem,
  dark = true,
}: {
  navItem: NavItemProps
  dark?: boolean
}) => {
  const { name, href, exist, host, isVip, isNew, items } = navItem
  const router = useRouter()

  const renderLink = (wrapperClassName?: string) => (
    <div
      className={classNames(
        'text-[14px] leading-4 pl-4 mr-6 relative last:mr-0',
        wrapperClassName
      )}
    >
      <MyLink
        href={href}
        exist={exist}
        host={host}
        className={classNames(
          dark ? 'hover:text-neutral-800' : 'hover:text-neutral-200',
          [
            router.pathname === href && exist
              ? 'text-neutral-800'
              : 'text-neutral-400',
          ]
        )}
      >
        {name}

        {isVip ? (
          <div className="absolute -right-6 -top-4">
            <CDNImage
              className="h-[14px]"
              src="/images/ai/vip_exclusive.png"
              alt=""
            />
          </div>
        ) : isNew ? (
          <div className="absolute -right-6 -top-4">
            <CDNImage className="h-[14px]" src="/images/new.png" alt="" />
          </div>
        ) : null}
      </MyLink>
    </div>
  )

  if (!items?.length) {
    return renderLink()
  }

  return (
    <Dropdown
      key={name}
      menu={{ items }}
      placement="bottomLeft"
      trigger={['hover']}
      overlayClassName={classNames('rounded-[8px]', {
        ['border border-neutral-200']: dark,
      })}
      getPopupContainer={(triggerNode: HTMLElement) =>
        triggerNode.parentNode as HTMLElement
      }
    >
      {renderLink()}
    </Dropdown>
  )
}
